import React, { useEffect, useState } from 'react'
import { Bar, BarChart, Cell, Legend, ResponsiveContainer, Tooltip } from 'recharts'
import CONSTANTS from '../../utils/constants'
import CustomTooltip from './CustomTooltip'

const getLegend = (data) => {
  return data.map((x, index) => ({
    value: x.name,
    type: 'square',
    color: CONSTANTS.COLORS[index % CONSTANTS.COLORS.length],
  }))
}

const CustomBarChart = ({ data }) => {
  const [legend, setLegend] = useState(getLegend(data))

  useEffect(() => {
    setLegend(getLegend(data))
  }, [data])

  return (
    <div className="pie-chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <Tooltip content={<CustomTooltip />} />
          <Legend payload={legend} height={50} wrapperStyle={{ overflow: 'auto' }} />
          <Bar dataKey="count" barSize={20} radius={[5, 5, 0, 0]}>
            {data.map((_, index) => (
              <Cell key={index} fill={CONSTANTS.COLORS[index % CONSTANTS.COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default CustomBarChart
